// @ts-nocheck
import {HttpError, HttpErrorType} from '@/core/request'
import {HttpErrorOptions} from "@/core/request/errors";

export type GraphqlErrorExtensions = {
    name?: string
    type?: string
    messages?: string[]
    code?: number
    alertShow?: boolean
    alertMessage?: string
    targetShow?: boolean
    targetMessage?: string
    debug?: any
} & Record<string, any>

/**
 * Структура GraphQL ошибки
 */
export interface GraphqlError {
    message: string
    locations?: Array<{
        line: number
        column: number
    }>
    path?: string[]
    extensions?: GraphqlErrorExtensions
}

export class GenqlError extends HttpError {
    error: GraphqlError
    errors: Array<GraphqlError> = []
    /**
     * Partial data returned by the server
     */
    data?: any

    constructor(errors: GraphqlError[], data: any) {
        const error = errors[0]!
        super(error.message, GenqlError.extensionsToOptions(error.extensions))
        this.errors = errors
        this.error = error
        this.data = data
    }

    static extensionsToOptions(ext: GraphqlErrorExtensions): HttpErrorOptions {
        return {
            type: ext.type || HttpErrorType.SERVER_ERROR,
            name: ext.name || 'graphql_error',
            alertShow: ext.alertShow ?? false,
            alertMessage: ext.alertMessage,
            targetShow: ext.targetShow ?? false,
            targetMessage: ext.targetMessage,
            isRetryable: this.isRetryableType()
        }
    }

    static isRetryableType(type: HttpErrorType): boolean {
        const retryableTypes = [
            HttpErrorType.TIMEOUT,
            HttpErrorType.NETWORK,
            HttpErrorType.SERVER_ERROR,
            HttpErrorType.EMPTY_RESPONSE,
            HttpErrorType.RATE_LIMIT
        ]
        return retryableTypes.includes(type)
    }

    getExtensions(): GraphqlErrorExtensions {
        return this.error.extensions || {}
    }


}
